const initialstate = {
    editdata:[],
    data:[],
    viewdata:[],
  }
  
  const OrgAddNeedsReducers =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_Edit_data_success':
            return {... state, editdata:action.payload};
            case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'fetch_needs_data_success':
                return {... state, viewdata:action.payload};
                       default :
            return state;
    }
  };
  export default OrgAddNeedsReducers;